import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
const PIXEL_ID = '815191254681970';
export function MetaPixel() {
  useEffect(() => {
    // Prevent duplicate initialization
    if (typeof window.fbq === 'function') {
      return;
    }
    // Create fbq function
    function fbq(...args: any[]) {
      if ((fbq as any).callMethod) {
        ;
        (fbq as any).callMethod.apply(fbq, args);
      } else {
        ;
        (fbq as any).queue.push(args);
      }
    }
    ;
    (fbq as any).push = fbq;
    (fbq as any).loaded = true;
    (fbq as any).version = '2.0';
    (fbq as any).queue = [];
    window.fbq = fbq;
    window._fbq = fbq;
    // Create and inject the script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Insert script into head
    const firstScript = document.getElementsByTagName('head')[0];
    if (firstScript) {
      firstScript.appendChild(script);
    }
    // Initialize pixel with ID
    window.fbq('init', PIXEL_ID);
    // Track PageView event
    window.fbq('track', 'PageView');
  }, []);
  // Noscript fallback for users without JavaScript
  return <noscript data-id="element-114">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-115" />
    </noscript>;
}